import { useEffect, useState, type FormEvent } from 'react';
import { Button } from '../ui/Button';
import { useAuth } from './store';
import { authErrorFromUrl } from './urlError';

export function LoginScreen() {
  const { signInWithGoogle, signInWithPassword, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [urlError, setUrlError] = useState<string | null>(null);
  // ошибка OAuth приходит в адресе; показали — и вычистили адрес, чтобы она не пережила перезагрузку
  useEffect(() => {
    const e = authErrorFromUrl(window.location.search, window.location.hash);
    if (!e) return;
    setUrlError(e);
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setUrlError(null);
    await signInWithPassword(email.trim(), password);
    setBusy(false);
  };

  return (
    <main className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-paper border border-line rounded-xl p-8 shadow-sm text-center">
        <h1 className="text-2xl font-bold mb-1">OctopiPoker Roadmap</h1>
        <p className="text-ink-muted mb-6">Sign in with your octopipoker.ai account.</p>

        <Button size="lg" className="w-full" onClick={() => { setUrlError(null); void signInWithGoogle(); }}>
          Continue with Google
        </Button>

        <button
          type="button"
          className="mt-4 text-accent underline underline-offset-4 text-sm min-h-0"
          onClick={() => setShowPassword((v) => !v)}
        >
          {showPassword ? 'Hide password sign-in' : 'Sign in with email and password'}
        </button>

        {showPassword && (
          <form onSubmit={(e) => void submit(e)} className="mt-4 flex flex-col gap-3">
            <label className="flex flex-col gap-1 text-left">
              <span className="font-medium">Email</span>
              <input
                type="email" required autoComplete="username" value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border border-line rounded-md px-3 py-2 text-base"
              />
            </label>
            <label className="flex flex-col gap-1 text-left">
              <span className="font-medium">Password</span>
              <input
                type="password" required autoComplete="current-password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="border border-line rounded-md px-3 py-2 text-base"
              />
            </label>
            <Button type="submit" variant="secondary" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
        )}

        {(error ?? urlError) && (
          <p role="alert" className="mt-4 text-danger font-medium" data-login-error>{error ?? urlError}</p>
        )}
      </div>
    </main>
  );
}
